<script>
import { Line } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
} from 'chart.js'

ChartJS.register(
    Title,
    Tooltip,
    Legend,
    LineElement,
    LinearScale,
    CategoryScale,
    PointElement
)

export default {
  extends: Line,
  props: {
    labelsData: {
      type: Array,
      require: true,
      default: () => [],
    },
    chartData: {
      type: Array,
      require: true,
      default: () => [],
    },
  },
  methods: {
    renderChartLayout() {
      this.renderChart(
        {
          labels: this.labelsData,
          datasets: this.chartData,
        },
        {
          responsive: true,
          maintainAspectRatio: false,
        }
      );
    },
  },
  watch: {
    labelsData: function (val) {
      this.renderChartLayout();
    },
    chartData: function (val) {
      this.renderChartLayout();
    },
  },
  mounted() {
    this.renderChartLayout();
  },
};
</script>
